<template>
  <div class="iframIndex" id="iframIndex"></div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { encrypt, addClass, removeClass } from "@/util/util";
  import { base64Encode } from "@/util/endecode.js";

  export default {
    name: "ifram",
    props: ['fpath'],
    data() {
      return {
        preUrl: process.env.VUE_APP_ACCOUNT_CLOUD_BASE_URL,
        routerPath: this.fpath ? this.fpath : this.$route.path,
        routerParms: this.fpath ? '' : this.$route.query,
        parmStr: "",
        themeType: ""
      };
    },
    watch: {
      $route: {
        handler: function(val, oldVal) {
          if (!this.fpath) {
            this.routerPath = val.path;
            this.routerParms = val.query;
          }
        },
        // 深度观察监听
        deep: true
      },
      routerPath: {
        handler(newVal, oldVal) {
          this.$nextTick(function() {
            if (newVal) {
              this.createIframe();
            }
          });
        },
        immediate: true,
        deep: true
      }
    },
    created() {
      this.preUrl = process.env.VUE_APP_ACCOUNT_CLOUD_BASE_URL;
      this.themeType = this.$store.getters.themeType;
      var lang = localStorage.getItem("lang");
      lang = lang || 'zh' ;
      if (!this.themeType) {
        this.themeType = "";
      }
      this.parmStr = "lang=" + base64Encode(lang) + "&accessToken=" + this.$store.getters.accessToken + "&aacode=invoice";
    },
    mounted() {
      this.$nextTick(function() {
        addClass(document.getElementsByTagName("body")[0], "pubIndex");
      });
    },
    destroyed() {
      // removeClass(document.getElementsByTagName("body")[0], "pubIndex");
    },
    methods: {
      createIframe() {
        // 为了解决浏览器回退的路由问题
        // 如果当前存在iframe,销毁它
        var div = document.getElementById("iframIndex");
        if (!this.fpath) {
          if (div.firstChild) div.removeChild(div.firstChild);
        }
        // 创建iframe
        var iframe = document.createElement("iframe");
        iframe.id = "main";
        iframe.ref = this.preUrl;
        var url = this.getRouter(this.preUrl, this.routerPath, this.routerParms, this.parmStr);
        //console.log("ciicurl:" +  url);
        iframe.src = url;
        iframe.frameborder = "0";
        iframe.width = "100%";
        iframe.height = "100%";
        document.getElementById("iframIndex").appendChild(iframe);
      },
      getRouter: function(preUrl, routePath, routeParms, parmStr) {
        // console.log("地址：：", preUrl, "  route:", routePath, "  路由参数：", routeParms, "  参数：", parmStr);
        addClass(document.getElementsByTagName("body")[0], "pubIndex");
        routePath += (routePath.indexOf("?") < 0 ? "?" : "&");
        if (routeParms) {
          if(routeParms.accountingParams){
            return preUrl + routePath + parmStr + "&" + routeParms.accountingParams;
          }else{
            let routeParmStr = "";
            for (let key in routeParms) {
              routeParmStr += "&" + key + "=" + routeParms[key];
            }
            return preUrl + routePath + parmStr + routeParmStr;
          }
        } else {
          return preUrl + routePath + parmStr;
        }
        return "";
      }
    }
  };
</script>

<style scoped>
  .iframIndex{
    /*height: calc(100% - 60px);*/
    height: 100%;
    /*height: 100%;*/
    box-sizing: border-box;
    background-color: #fff;
    padding: 20px 0;
  }
</style>
